/*
 * @Author: cuikj kaijun.cui@biz-united.com.cn
 * @Date: 2024-05-20 14:34:38
 * @LastEditors: Tang Hao
 * @LastEditTime: 2026-01-05 19:20:47
 * @Description:
 */
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import PaymentDetails from './paymentDetails.vue';

formCreate.component('PaymentDetails', PaymentDetails);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      progressList: [],
      chooseAct: [],
      formFunctionCode: 'payment_details',
      formParentCode: 'CRM2020122800000887',
      buttons: {
        submit: false,
        close: true,
        loading: false,
      },

    };
  },

  async created() {
    this.init();
  },
  mounted() {
    if (this.formConfig.code !== 'fillin') {
      this.buttons = {
        submit: false,
        close: true,
        loading: false,
      };
    }
    if (this.formConfig.code === 'fillin') {
      this.buttons = {
        submit: true,
        close: true,
        loading: false,
      };
    }
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (this.formConfig.code === 'fillin') {
        v.hidden = false;
      } else {
        v.hidden = true;
      }
      v.props = {
        ...v.props,
        disabled: true,
      };
      if (v.field === 'errorMsg') {
        v.props = {
          ...v.props,
          disabled: false,
          autosize: {
            minRows: 4, maxRows: 6,
          },
          rows: 4,
        };
      }

      return v;
    },

    formComplete() {
      if (this.formConfig.code === 'fillin') {
        this.fApi.hidden(true, ['paymentDetails']);
      } else {
        this.fApi.hidden(false, ['paymentDetails']);
      }

      const paymentDetails = this.getRule('paymentDetails'); // 支付明细列表
      paymentDetails.props = {
        ...paymentDetails.props,
        actCode: this.formConfig.row.actCode,
        code: this.formConfig.code,
      };
      // 活动明细列表
      // paymentDetails.on.change = (e) => {
      //   if (e) {
      //     console.log(e);
      //   }
      // };
      this.getDetail();
    },
    // 查询详情
    getDetail() {
      const { row } = this.formConfig;
      this.setValue({
        ...row,
      });
    },
    submit() {
      const formData = this.getFormData();
      if (formData) {
        request.patch('/tax/v1/terminalCash/api/remark', { id: this.formConfig.row.id, errorMsg: formData.errorMsg }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
    // 初始化数据
    async init() {
      const { row } = this.formConfig;
      const data = await request
        .post('/tax/v1/terminalCash/api/findCashDetailByConditions', {
          id: row.id,
        })
        .then((res) => (res.success ? res.result : []));
      const paymentDetails = this.getRule('paymentDetails'); // 活动明细列表
      paymentDetails.value = data || {};
      this.setValue(data);
    },
  },
};
